module.exports = __webpack_public_path__ + "static/media/Rec_Candidates.06b47f79.png";